<div class="audit-permissions container mx-auto p-6">
  <h1 class="audit-permissions__page-title mb-6">Revisão de Permissões — Relatório de Atendimento</h1>

  <!-- Matriz de Permissões -->
  <section class="audit-permissions__section mb-8">
    <h2 class="audit-permissions__section-title mb-4">Matriz de Permissões por Perfil</h2>
    <p class="audit-permissions__description mb-4">
      A tabela abaixo exibe quais perfis possuem permissão de acesso ao módulo de Relatório de Atendimento,
      incluindo visualização, edição e exportação de dados sensíveis.
    </p>

    <div class="table-responsive">
      <table class="audit-permissions__table w-full">
        <thead>
          <tr>
            <th>Perfil</th>
            <th>Acessar Relatório</th>
            <th>Editar Relatório</th>
            <th>Exportar Excel</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of permissoesPerfis">
            <td class="font-medium">{{ p.perfil }}</td>
            <td>
              <mat-icon [class]="p.acessarRelatorio ? 'icon--allowed' : 'icon--denied'">
                {{ p.acessarRelatorio ? 'check_circle' : 'cancel' }}
              </mat-icon>
            </td>
            <td>
              <mat-icon [class]="p.editarRelatorio ? 'icon--allowed' : 'icon--denied'">
                {{ p.editarRelatorio ? 'check_circle' : 'cancel' }}
              </mat-icon>
            </td>
            <td>
              <mat-icon [class]="p.exportarExcel ? 'icon--allowed' : 'icon--denied'">
                {{ p.exportarExcel ? 'check_circle' : 'cancel' }}
              </mat-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- Histórico de Aceites -->
  <section class="audit-permissions__section">
    <div class="flex items-center justify-between mb-4">
      <h2 class="audit-permissions__section-title">Histórico de Aceite do Disclaimer</h2>
      <button
        *ngIf="auditLog.length > 0"
        class="btn btn--secondary px-4 h-35"
        (click)="limparHistorico()"
      >
        Limpar Histórico
      </button>
    </div>

    <p class="audit-permissions__description mb-4">
      Registro dos usuários que aceitaram o aviso de dados sensíveis e acessaram o relatório.
    </p>

    <div *ngIf="auditLog.length === 0" class="audit-permissions__empty">
      Nenhum registro encontrado.
    </div>

    <div *ngIf="auditLog.length > 0" class="table-responsive">
      <table class="audit-permissions__table w-full">
        <thead>
          <tr>
            <th>Data/Hora</th>
            <th>Usuário</th>
            <th>Perfil</th>
            <th>E-mail</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of auditLog">
            <td>{{ entry.timestamp | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td>{{ entry.userName }}</td>
            <td>{{ entry.role }}</td>
            <td>{{ entry.email }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
